// The shared empty state (#139) — a DESIGNED "this collection is genuinely empty"
// view, distinct from Loading and from ErrorState. Parameterized so each screen
// supplies its own copy + an optional next-step CTA (e.g. "Claim a camera"),
// turning a first-run dead end into onboarding. (Distinct from the unauthenticated
// affordance — see SignedOut.)

export interface EmptyStateProps {
  /** A glyph for the empty art (defaults to the gallery tile mark). */
  icon?: React.ReactNode;
  title: string;
  message?: React.ReactNode;
  /** Optional primary next-step. Both `ctaLabel` and `onCta` are required to render it. */
  ctaLabel?: string;
  onCta?: () => void;
}

export function EmptyState({
  icon = "▦",
  title,
  message,
  ctaLabel,
  onCta,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div className="empty" data-testid="empty-state">
      <div className="empty__art" aria-hidden="true">
        {icon}
      </div>
      <h2 className="empty__title">{title}</h2>
      {message != null && <p className="empty__body">{message}</p>}
      {ctaLabel && onCta && (
        <button
          type="button"
          className="btn btn--primary empty__cta"
          onClick={onCta}
          data-testid="empty-cta"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
